// src/pages/Support.js
import React, { useState } from "react";
import emailjs from "@emailjs/browser";

function Support() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState(""); // To display success/error messages

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Replace these with your actual EmailJS credentials
    const serviceID = "service_yi65vla";
    const templateID = "template_h7v7x0g";
    const userID = "GHhw205kUp0YX2-yH";

    emailjs
      .send(serviceID, templateID, formData, userID)
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setStatus("Thank you for your feedback!");
          setFormData({ name: "", email: "", message: "" }); // Reset form
        },
        (err) => {
          console.error("FAILED...", err);
          setStatus("Failed to send feedback. Please try again later.");
        }
      );
  };

  return (
    <div style={styles.container}>
      <h1>Feedback</h1>
      <form onSubmit={handleSubmit} style={styles.form}>
        <label style={styles.label}>
          Name:
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            style={styles.input}
          />
        </label>
        <label style={styles.label}>
          Email:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            style={styles.input}
          />
        </label>
        <label style={styles.label}>
          Message:
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            style={{ ...styles.input, height: "150px" }}
          />
        </label>
        <button type="submit" style={styles.button}>
          Submit
        </button>
      </form>
      {status && <p style={styles.status}>{status}</p>}
    </div>
  );
}

const styles = {
  container: {
    padding: "2rem",
    maxWidth: "600px",
    margin: "0 auto",
    color: "var(--text-color)",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  label: {
    display: "flex",
    flexDirection: "column",
    fontSize: "1rem",
  },
  input: {
    padding: "0.5rem",
    borderRadius: "4px",
    border: "1px solid var(--dim-gray)",
    backgroundColor: "var(--dim-gray)",
    color: "var(--text-color)",
  },
  button: {
    padding: "0.75rem",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "var(--steel-blue)",
    color: "#fff",
    fontSize: "1rem",
    cursor: "pointer",
  },
  status: {
    marginTop: "1rem",
    fontSize: "1rem",
    color: "#4CAF50", // Green for success; adjust as needed
  },
};

export default Support;